export const data = [
    {
        "thumbnail": "https://i.ytimg.com/vi/J7IuQSZdzYw/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLD-JFlNEuAFqMRKG13ArH61ahdO0g",
        "channelLogo": "https://yt3.ggpht.com/ytc/AGIKgqPAl3A8_-KRf7MfN3oCr-NbQNY0A0By7tenqALJdA=s68-c-k-c0x00ffffff-no-rj",
        "title": "Jai Shri Ram (Telugu)Adipurush | Prabhas | Ajay-Atul, Manoj...",
        "channel": "T-Series Telugu",
        "views": "2.5M",
        "date": "8 hours",
        "duration": "2:39",
    },
    {
        "thumbnail": "https://i.ytimg.com/vi/0n7AWxYCj9I/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDUChiH24-GK6MgafIoIeMz8AMZ1A",
        "channelLogo": "https://yt3.ggpht.com/ZnBmMi35bqmVJODSRzSwo3_j3WVaBd3DhRJHrKTS4yMX4jds1gXOsH0JpjBtr4HzfNClZcnjWw=s68-c-k-c0x00ffffff-no-rj",
        "title": "Na Roja Nuvve | Kushi | Vijay Devarakonda | Samantha Ruth Prabhhu ...",
        "channel": "Saregama Telugu",
        "views": "15M",
        "date": "11 days",
        "duration": "4:14",
    },
    {
        "thumbnail": "https://i.ytimg.com/vi/pCWZ6xCm450/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDp9163RS6hsWPx9_-4Cq9a0otV2g",
        "channelLogo": "https://yt3.ggpht.com/59YBnOdoC_beFI-UTkrNRsa-uQQyvLgo-XofWZDUscP8qN60y0HYdMwZExRvDJKEJUCyH5zR=s68-c-k-c0x00ffffff-no-rj",
        "title": "Never Give Up - Best Motivational speech video | Morning #motivation",
        "channel": "MyDearSoul",
        "views": "218K",
        "date": "2 weeks",
        "duration": "5:42",
    },
    {
        "thumbnail": "https://i.ytimg.com/vi/0PKFQciUWBU/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLD32NoBrabGETRBXS8IcVlMBo5jsw",
        "channelLogo": "https://yt3.ggpht.com/ytc/AGIKgqOvG2l_sPRho5ycMPk-RwXjY-BtO1KYOG-xLjm1YQ=s68-c-k-c0x00ffffff-no-rj",
        "title": "Inkjet Printers | The interesting engineering behind them",
        "channel": "Lesics",
        "views": "3.5M",
        "date": "1 year",
        "duration": "11:25",
    },
    {
        "thumbnail": "https://i.ytimg.com/vi/bOCHTHkBoAs/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAYhmA8HAc6Ap7KpVRbWAXMVDq5Aw",
        "channelLogo": "https://yt3.ggpht.com/ytc/AGIKgqOSWK9LIZ9xGvDbBZ7gjBK1ayNCxK0jKMOq1FirfA=s68-c-k-c0x00ffffff-no-rj",
        "title": "10 Math Concepts for Programmers",
        "channel": "Fireship",
        "views": "893K",
        "date": "4 weeks",
        "duration": "9:32",
    },
    {
        "thumbnail": "https://i.ytimg.com/vi/dTRBnHtHehQ/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBGDUIqRGCR7IIGhXqZyqM5LrhMfA",
        "channelLogo": "https://yt3.ggpht.com/ytc/AGIKgqMnO-ISfsiSLEp3dF3Fw9sSLmAAo_qZgtoF0snu=s68-c-k-c0x00ffffff-no-rj",
        "title": "Kobe Bryant's Greatest Speech | BEST Motivation Ever",
        "channel": "Outcast Motivation",
        "views": "4.5M",
        "date": "1 Year ago",
        "duration": "12:30",
    },
    {
        "thumbnail": "https://i.ytimg.com/vi/mB8Pxm3Gouk/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAjkVCGtgagt3vX-dnrYyfO_Pt5rw",
        "channelLogo": "https://yt3.ggpht.com/ytc/AGIKgqMUZ7OA7O2dtRk1RmEQHO1F5afdORKXmU7GR1GE=s68-c-k-c0x00ffffff-no-rj",
        "title": "INDIA NEED 11 RUNS AND 1 WICKET LEFT | THRILLER",
        "channel": "Gold Cricket",
        "views": "4.9M",
        "date": "6 months",
        "duration": "6:47",
    },
    {
        "thumbnail":"https://i.ytimg.com/vi/Fp8a_J2wIUw/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLB6eDcE-35T4GfRPgDbCdRESRwsOw" ,
        "channelLogo": "https://yt3.ggpht.com/0B-bLdqKnHAHCZREVZUiEFKiMo3yn-_NdcoLjy34upXh9RIO0IXA0i0uioZXhEMWAj1_rxCEhWM=s68-c-k-c0x00ffffff-no-rj",
        "title": "The Finisher finishes the Journey | Tribute to MS Dhoni | End of an Era | ...",
        "channel": "PrimeMojo",
        "views": "917K",
        "date": "@ years",
        "duration": "7:29",
    },
    {
        "thumbnail": "https://i.ytimg.com/vi/uD4izuDMUQA/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCFOuqybjzzNvm-k8uyA3PB1Xp7nQ",
        "channelLogo": "https://yt3.ggpht.com/ytc/AGIKgqPS9Wa5pgHrprIKfUI7mWNpb1E72XISbn5B2njLZA=s68-c-k-c0x00ffffff-no-rj",
        "title": "TIMELAPSE OF THE FUTURE: A Journey to the End of Time (4K)",
        "channel": "melodysheepcs",
        "views": "92M",
        "date": "4 years",
        "duration": "29:21",
    },
    {
        "thumbnail": "https://i.ytimg.com/an_webp/M3ygFVrfR6E/mqdefault_6s.webp?du=3000&sqp=CKG2pKMG&rs=AOn4CLCY9SpIVHIi1OH4az6o5hbscQRL0Q",
        "channelLogo": "https://yt3.ggpht.com/fRTh6Q0FUUZ50HFjtiUw_5DeDhQy87dhpUOdLzPySHsZXipNu3lpD4R9oxyKUzXY_DDUVPZB=s68-c-k-c0x00ffffff-no-rj",
        "title": "Bumrah With The Bat! | 35 Runs In One Over Against Stuart Broad! |...",
        "channel": "England & Wales Cricket Board",
        "views": "28M",
        "date": "7 months",
        "duration": "8:33",
    },
    {
        "thumbnail": "https://i.ytimg.com/vi/cNfINi5CNbY/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAnGcAn7f41sP9CEhmtREMGSX7m_g",
        "channelLogo": "https://yt3.ggpht.com/ytc/AGIKgqNELVORcqrjjetO_QWWa21hdnDfheNgIKktwy8G9d8=s68-c-k-c0x00ffffff-no-rj",
        "title": "Google Keynote (Google I/O '23)",
        "channel": "Google",
        "views": "1.4M",
        "date": "Streamed 10 days",
        "duration": "2:05:20",
    },
    {
        "thumbnail": "https://i.ytimg.com/vi/sBBMRBVvVis/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCZ15Uz2aGMzdsG-XHwqsFzJfiWiQ",
        "channelLogo": "https://yt3.ggpht.com/nTK6AFZrpjDHKNIHq0zqjkWCs3jm9ttQBAGOfIui0zlz_gQzeqAIOtQKfzbSUIA0Mu15HBDfCg=s68-c-k-c0x00ffffff-no-rj",
        "title": "Will ONDC KILL Zomato & Swiggy? : Business case study",
        "channel": "Think School",
        "views": "2.2",
        "date": "11 months",
        "duration": "2:05:20",
    },
    {
        "thumbnail": "https://i.ytimg.com/vi/pCWZ6xCm450/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDp9163RS6hsWPx9_-4Cq9a0otV2g",
        "channelLogo": "https://yt3.ggpht.com/59YBnOdoC_beFI-UTkrNRsa-uQQyvLgo-XofWZDUscP8qN60y0HYdMwZExRvDJKEJUCyH5zR=s68-c-k-c0x00ffffff-no-rj",
        "title": "Never Give Up - Best Motivational speech video | Morning #motivation",
        "channel": "MyDearSoul",
        "views": "218K",
        "date": "2 weeks",
        "duration": "5:42",
    },
    {
        "thumbnail": "https://i.ytimg.com/vi/J7IuQSZdzYw/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLD-JFlNEuAFqMRKG13ArH61ahdO0g",
        "channelLogo": "https://yt3.ggpht.com/ytc/AGIKgqPAl3A8_-KRf7MfN3oCr-NbQNY0A0By7tenqALJdA=s68-c-k-c0x00ffffff-no-rj",
        "title": "Jai Shri Ram (Telugu)Adipurush | Prabhas | Ajay-Atul, Manoj...",
        "channel": "T-Series Telugu",
        "views": "2.5M",
        "date": "8 hours",
        "duration": "2:39",
    },
    {
        "thumbnail": "https://i.ytimg.com/vi/0PKFQciUWBU/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLD32NoBrabGETRBXS8IcVlMBo5jsw",
        "channelLogo": "https://yt3.ggpht.com/ytc/AGIKgqOvG2l_sPRho5ycMPk-RwXjY-BtO1KYOG-xLjm1YQ=s68-c-k-c0x00ffffff-no-rj",
        "title": "Inkjet Printers | The interesting engineering behind them",
        "channel": "Lesics",
        "views": "3.5M",
        "date": "1 year",
        "duration": "11:25",
    },

    {
        "thumbnail": "https://i.ytimg.com/vi/dTRBnHtHehQ/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBGDUIqRGCR7IIGhXqZyqM5LrhMfA",
        "channelLogo": "https://yt3.ggpht.com/ytc/AGIKgqMnO-ISfsiSLEp3dF3Fw9sSLmAAo_qZgtoF0snu=s68-c-k-c0x00ffffff-no-rj",
        "title": "Kobe Bryant's Greatest Speech | BEST Motivation Ever",
        "channel": "Outcast Motivation",
        "views": "4.5M",
        "date": "1 Year ago",
        "duration": "12:30",
    },
]